import { render, staticRenderFns } from "./Printers.vue?vue&type=template&id=f4fbbcf8&scoped=true"
import script from "./Printers.vue?vue&type=script&lang=js"
export * from "./Printers.vue?vue&type=script&lang=js"
import style0 from "./Printers.vue?vue&type=style&index=0&id=f4fbbcf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fbbcf8",
  null
  
)

export default component.exports